import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SidebarContent } from './Sidebar';
import { SwoopLayout } from './Layout';

export const navModule = createFrontendModule({
  pluginId: 'app',
  extensions: [SidebarContent, SwoopLayout],
});
